__turbopack_context__.v({
  "category": "Footer-module-scss-module__q5ZVWW__category",
  "grid": "Footer-module-scss-module__q5ZVWW__grid",
  "grid_0": "Footer-module-scss-module__q5ZVWW__grid_0",
  "grid_1": "Footer-module-scss-module__q5ZVWW__grid_1",
  "grid_2": "Footer-module-scss-module__q5ZVWW__grid_2",
  "grid_3": "Footer-module-scss-module__q5ZVWW__grid_3",
  "grid_4": "Footer-module-scss-module__q5ZVWW__grid_4",
  "grid_5": "Footer-module-scss-module__q5ZVWW__grid_5",
  "grid_6": "Footer-module-scss-module__q5ZVWW__grid_6",
  "logo__bottom": "Footer-module-scss-module__q5ZVWW__logo__bottom",
  "newsletter": "Footer-module-scss-module__q5ZVWW__newsletter",
  "sanity": "Footer-module-scss-module__q5ZVWW__sanity",
});
